export class CalculationStrategy {
    constructor() { }
    calculate(calculationData) { }
}